export default [
  {
    text: 'Нет',
    value: 'no',
  },
  {
    text: 'Магистральный в доме или на участке',
    value: 'main',
  },
  {
    text: 'Магистральный по границе участка',
    value: 'border',
  },
  {
    text: 'Газгольдер',
    value: 'gasHolder',
  },
];
